import { Box } from '@chakra-ui/react'
import * as React from 'react'
import styled from '@emotion/styled'

import { vw } from '../../styles/theme'
import Button, { ButtonProps } from './Button'
import usePageColor from '../../hooks/usePageColor'

export type ButtonHamburgerProps = ButtonProps & {
  isOpen: boolean
}

const LineBase = ({ ...others }) => <Box w="100%" h={vw(2)} {...others} />
const Line = styled(LineBase)``

const ButtonHamburger: React.FC<ButtonHamburgerProps> = ({ isOpen, ...others }) => {
  const color = usePageColor()
  const w = 20
  const h = 17
  const lh = 2
  const oy = (h - lh) * 0.5
  return (
    <>
      <Button
        variant="unstyled"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minW="0"
        minH="0"
        w={vw(w)}
        h={vw(h)}
        css={{
          [Line]: {
            transition: 'all 500ms cubic-bezier(0.23, 1, 0.32, 1)',
            background: 'currentcolor',
            transformOrigin: 'center',
            transform: isOpen ? 'scale(0)' : 'scale(1)',
            '&:first-of-type': {
              transform: isOpen ? `translateY(${vw(oy)}) rotate(45deg)` : 'rotate(0)',
            },
            '&:last-of-type': {
              transform: isOpen ? `translateY(${vw(-oy)}) rotate(-45deg)` : 'rotate(0)',
            },
          },
        }}
        {...others}
      >
        <Line color={color} />
        <Line color={color} />
        <Line color={color} />
        <Line color={color} />
      </Button>
    </>
  )
}

export default ButtonHamburger
